import React, { SyntheticEvent } from 'react'
import { Grid, Dropdown } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

//@ts-ignore
import { GridContainer, ComponentContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { LocalLoader } from 'shared'

import translate from '../../translator'
import Modals, { openReserveManualModal, openReserveAutoModal } from './Modals'
import { actions as DetailsContainerActions } from '../../../DetailsContainer'

import { ControlsProps } from '../../types.LoanDetails'

function reload(ID: string, hash: string, page: string) {
  return DetailsContainerActions.fetchPage({
    type: 'Loan',
    ID,
    hash,
    page,
  })
}

const transformOptions = (options) => options.map((option) => ({ value: option.ID, text: option.Category }))

@withRouter
//@ts-ignore
@connect(undefined, (dispatch, { match: { params: { ID, hash } } }) => ({
  openReserveManualModal: (manRateID: string) => dispatch(openReserveManualModal(ID, hash, manRateID)),
  openReserveAutoModal: () => dispatch(openReserveAutoModal(ID, hash)),
  onRefresh: () => {
    dispatch(reload(ID, hash, 'base'))
    dispatch(reload(ID, hash, 'reserveauto'))
    dispatch(reload(ID, hash, 'reserveman'))
  },
}))
class Controls extends React.PureComponent<ControlsProps> {
  static defaultProps = {
    manRates: [],
  }

  state = {
    selectedManRatesID: undefined,
  }

  handleChangeManRates = (_: SyntheticEvent, data: {value: number}) => {
    this.setState({ selectedManRatesID: data.value })
  }

  handleOpenReserveManualModal = () => {
    this.props.openReserveManualModal(this.state.selectedManRatesID || this.props.manRates[0].ID)
  }

  render() {
    return (
      <GridContainer>
        <Grid>
          <Modals onRefresh={this.props.onRefresh} />

          <Grid.Row>
            <Grid.Column width={4} verticalAlign="middle">
              <LKButton
                alias="auto_reserve"
                fluid
                size="medium"
                onClick={this.props.openReserveAutoModal}
                permission="LOAN_RESERVE_CHANGE"
              >
                {translate('cmd_end_manual')}
              </LKButton>
            </Grid.Column>

            <Grid.Column width={4} verticalAlign="middle">
              <LocalLoader loading={!this.props.manRates.length}>
                {!!this.props.manRates.length && (
                  <ComponentContainer dropdown>
                    <Dropdown
                      options={transformOptions(this.props.manRates)}
                      defaultValue={this.props.manRates[0].ID}
                      onChange={this.handleChangeManRates}
                      search
                      button
                      fluid
                      selection
                      upward
                    />
                  </ComponentContainer>
                )}
              </LocalLoader>
            </Grid.Column>

            <Grid.Column width={3} verticalAlign="middle">
              <LKButton
                alias="pc_alert"
                fluid
                size="medium"
                onClick={this.handleOpenReserveManualModal}
                permission="LOAN_RESERVE_CHANGE"
              >
                {translate('cmd_start_manual')}
              </LKButton>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </GridContainer>
    )
  }
}

export default Controls
